import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Rajesh Verma",
    role: "Director, RV Enterprises",
    text: "AVS Associates handled our entire GST compliance flawlessly. Their expertise in GST return filing and notice replies saved us from potential penalties. Highly recommended!",
  },
  {
    name: "Priya Sharma",
    role: "Founder, PS Exports",
    text: "The team's knowledge of IEC registration and import-export compliance is exceptional. They made the entire process seamless and we were operational within weeks.",
  },
  {
    name: "Ankit Gupta",
    role: "Partner, AG Industries",
    text: "Sagar Tiwari personally handled our Income Tax appeal case with great professionalism. His legal expertise and thorough understanding of tax law resulted in a favorable outcome.",
  },
  {
    name: "Meena Jain",
    role: "CEO, MJ Retail Solutions",
    text: "From company incorporation to ongoing compliance, AVS Associates has been our trusted partner. Their end-to-end business support is truly remarkable.",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 md:py-32 bg-[#0A0D14] relative"
    >
      <div className="gold-line w-24 mx-auto mb-16" />

      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="text-center mb-16">
          <p className="font-work text-sm font-semibold tracking-[0.2em] text-[#D4AF37] uppercase mb-4">
            Client Voices
          </p>
          <h2 className="font-outfit text-3xl md:text-4xl lg:text-5xl font-light tracking-tight text-white">
            Trusted by Businesses
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.5 }}
              data-testid={`testimonial-${i}`}
              className="bg-[#131821] border border-white/5 p-8 relative group hover:border-[#D4AF37]/20 transition-all duration-300"
            >
              <Quote
                size={32}
                className="text-[#D4AF37]/15 absolute top-6 right-6"
              />
              <p className="font-work text-[#94A3B8] text-base leading-relaxed mb-6 relative z-10">
                "{t.text}"
              </p>
              <div className="border-t border-white/5 pt-4">
                <p className="font-outfit text-white font-medium text-sm">
                  {t.name}
                </p>
                <p className="font-work text-[#D4AF37] text-xs tracking-wide">
                  {t.role}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
